import { createSelector } from '@ngrx/store';
import { getDragonflySharedState } from '../../reducers';

export const getLiteralsState = createSelector(getDragonflySharedState, (state) => state.literals);

export const getOrderDesc = createSelector(getLiteralsState, ({ literals }) => literals['liquid.search.sort.desc']);

export const getOrderAsc = createSelector(getLiteralsState, ({ literals }) => literals['liquid.search.sort.asc']);

export const getCreationDate = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.search.sort.tags.creation_date'],
);

export const getItems = createSelector(getLiteralsState, ({ literals }) => literals['liquid.search.filters.items']);

export const getSortField = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.search.filters.sortfield'],
);

export const getOrder = createSelector(getLiteralsState, ({ literals }) => literals['liquid.search.filters.order']);

export const getUserUserName = createSelector(getLiteralsState, ({ literals }) => literals['liquid.user.username']);

export const getUserDisplayedName = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.user.displayedname'],
);

export const getUserEmail = createSelector(getLiteralsState, ({ literals }) => literals['liquid.user.email']);

export const getStoreCreationDate = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.search.sort.stores.creation_date'],
);

export const getStoreCode = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.search.sort.stores.store_code'],
);
